import * as ProductType from '@/services/rest-api/lib/product/product-type'

const productFields = [
  {
    key: 'name',
    name: 'name',
    label: 'Nama Produk',
    placeholder: 'Nama Produk',
    type: 'text',
    validation: 'bail|required|max:255,length',
  },
  {
    key: 'product_type_id',
    name: 'product_type_id',
    type: 'select-resourceful-v2',
    label: 'Jenis Produk',
    placeholder: 'Jenis Produk',
    optionsGetter: ProductType.get,
    optionLabelFn: ({ item }) => {
      return item.product_category ? `${item.name} - ${item.product_category.name}` : item.name
    },
    validation: 'required',
  },
  {
    key: 'sku',
    name: 'sku',
    label: 'SKU',
    placeholder: 'SKU',
    type: 'text',
    validation: 'max:255,length',
  },
  {
    key: 'description',
    name: 'description',
    label: 'Deskripsi',
    placeholder: 'Deskripsi',
    type: 'text',
    validation: 'max:255,length',
  },
]

export default productFields
